import { APMM_CLIENT_COLLATERALS, APMM_ROUTER_CONFIG } from '@/client/confs/app';
import type { RouterConfig } from '@/libs/sdk/contracts/core/apmm-router-address';

// The only UI module that reads the router configuration. Everything else asks this hook.
// A half-set or invalid config already throws when app.ts loads, so the UI sees only off or on.

export { APMM_CLIENT_COLLATERALS };
export type { RouterConfig };

export const useApmmRouterConfig = (): RouterConfig => APMM_ROUTER_CONFIG;
